import { Component, Input, OnInit } from "@angular/core";
import { CoreMenuItem } from "../../../../../@core/types";

@Component({
    selector: "app-home-card",
    templateUrl: "./home-card.component.html",
    styleUrls: ["./home-card.component.scss"],
    standalone: false
})
export class HomeCardComponent implements OnInit {
  @Input() item: CoreMenuItem;

  constructor() {}

  ngOnInit(): void {}
}
